export default "__VITE_ASSET__Caac6A8f__"